import React from 'react';
import infoIcon from '../../images/otp-info.svg';
import closeIcon from '../../images/close.svg';

class WarningPopup extends React.Component {
  render () {
    if (this.props.show) {
      return null;
    }

    return (
      <React.Fragment>
        <button className="close-button" onClick={this.props.onClose}>
          <img src={closeIcon} className="close-icon" alt="close_icon" align="center" />
        </button>
        <div className="info-card-icon">
          <img
            src={infoIcon}
            className="info-icon"
            alt="info_icon"
            align="center"
          />
        </div>
        <div className="card-header info-card-header">

          <h2>We're improving our security!</h2>
          <p>
            In doing so, the One-Time Password (OTP) will be disabled as a login option.
            Going forward you will need your username and password to login.
          </p>
        </div>
        <div className="info-card-controls">
          <button className="btn btnRed" onClick={this.props.onClose}>
            Continue
          </button>
        </div>

      </React.Fragment>
    );
  }
}

export default WarningPopup;
